// extracted by mini-css-extract-plugin
export var checkbox = "_97-0";
export var circle = "_97-3";
export var horizontalContainer = "_97-7";
export var sm = "_97-5";
export var switch0 = "_97-2";
export var switchDisabled = "_97-8";
export var switchEnabled = "_97-1";
export var textSwitchContainer = "_97-9";
export var textSwitchOption = "_97-a";
export var textSwitchOptionSelected = "_97-b";
export var verticalContainer = "_97-6";
export var xs = "_97-4";